export default "__VITE_ASSET__DaT1Y0bM__"